<form class="container-fluid scene-form-wrapper pt-2" [formGroup]="sceneForm" [style.margin-bottom]="'65px'"
  style="user-select: none;">
  <div class="mt-2 mb-3">
    <!-- Scene Name -->
    <label class="form-label">Scene name</label>
    <input class="form-control" formControlName="name" placeholder="Scene Name" (focusout)="updateSceneAttribute('name')" [(ngModel)]="scene.name">
    @if (sceneForm.get('name').status=='INVALID') {
      <small class="form-text text-danger">
      Scene name is required</small>
    }
  </div>

  <div class="mb-3">
    <div class="d-flex">
      <!-- Container for the first button (conditionally rendered) -->
      <div class="flex-fill me-2">
        @if (scene.type !== 'Map') {
          <button class="btn btn-sm btn-success w-100"
            (click)="setStartingOrientation()">
            Set Starting Orientation
          </button>
        }
        @if (scene.type === 'Map') {
          <a class="btn btn-sm btn-success w-100"
            (click)="setMapsStartingOrientation()">
            Set Starting Orientation
          </a>
        }
      </div>
      <!-- Container for the second button -->
      <div class="flex-fill">
        <button class="btn btn-sm btn-success w-100" (click)="setSceneThumbnail()">
          Set Thumbnail
        </button>
      </div>
    </div>
  </div>

  @if (scene.type == 'Map' || scene.type == '360 Image') {
    <ul class="list-group mb-3">
      <!-- Terrain Property (Map scenes) -->
      @if (terrain && scene.type == 'Map') {
        <ng-container [formGroup]="terrain">
          <li class="list-group-item d-flex align-items-center pe-1">
            <span class="text-nowrap text-truncate me-auto" style="min-width:0;">3D terrain</span>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" formControlName="value"
                (change)="updateTerrain(terrain.value)" style="cursor: pointer;">
              </div>
            </li>
          </ng-container>
        }
        <!-- Map scenes -->
        @if (scene.type == 'Map') {
          <li class="list-group-item d-flex align-items-center" [formGroup]="style">
            <label class="form-label me-2 mb-0">Style</label>
            <select class="form-select w-auto ms-auto" formControlName="value"
              (change)="updateSceneProperty(style.value)" style="cursor: pointer">
              @for (mapstyle of mapStyles; track mapstyle) {
                <option [value]="mapstyle.style">
                  {{ mapstyle.display }}
                </option>
              }
            </select>
          </li>
        }
        <!-- Standard and 360 Scenes -->
        @if (scene.type == '360 Image') {
          <div class="mb-3">
            <!-- Scene File Property (360 Image scenes) -->
            @if (file) {
              <ng-container [formGroup]="file">
                <label class="form-label">Background image</label>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <span class="text-nowrap text-truncate me-auto" style="min-width:0;">
                    <i class="fas fa-file-image" style="width:20px;"></i>
                    <span class="ms-2">{{ fileReference?.filename }}</span>
                  </span>
                  <div class="d-flex align-items-center">
                    <a class="btn text-secondary px-1" title="Download"
                      (click)="downloadBackgroundFile(fileReference)">
                      <i class="fas fa-file-download"></i>
                    </a>
                    <label for="background" class="btn text-secondary px-1 mb-0" title="Replace">
                      <i class="fas fa-file-upload"></i>
                    </label>
                    <input id="background" type="file" accept="image/*" class="d-none"
                      (change)="replaceBackgroundFile($event.target.files[0])">
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="form-label mb-0">Relative North</label>
                      <button class="btn btn-sm btn-success" (click)="setNorthAngle()">
                        Record North
                      </button>
                    </div>
                    <small class="text-muted d-block mt-1">
                      Used to orient 360 scenes with one another.
                    </small>
                  </li>
                </ng-container>
              }
            </div>
          }
        </ul>
      }

      <button class="btn btn-secondary mb-3 w-100" type="button" (click)="toggleCollapse()">
        Advanced Settings
        <i [ngClass]="{'ms-2 fa': true, 'fa-caret-down': !showAdvanced, 'fa-caret-up': showAdvanced}"></i>
      </button>
      <div class="collapse" [class.collapse]="!showAdvanced" [class.show]="showAdvanced">
        <ul class="list-group mb-3">
          <!-- Scene of Interest -->
          <li class="list-group-item d-flex align-items-center pe-1">
            <span class="text-nowrap text-truncate me-auto" style="min-width:0;">Show in Viewer navigation
            panel</span>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" formControlName="sceneOfInterest" [(ngModel)]="scene.sceneOfInterest" (change)="updateSceneAttribute('sceneOfInterest')"
                style="cursor: pointer;">
              </div>
            </li>
            <!-- Overlap Property (Map scenes) -->
            @if (scene.type == 'Map') {
              <ng-container [formGroup]="overlap">
                <li class="list-group-item d-flex align-items-center pe-1">
                  <span class="text-nowrap text-truncate me-auto" style="min-width:0;">Hide markers on overlap</span>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" formControlName="value"
                      (change)="updateOverlapProperty(overlap.value)" style="cursor: pointer;" [checked]="sceneOverlap">
                    </div>
                  </li>
                </ng-container>
              }
              @if (timeOfDay && scene.type=='Map') {
                <ng-container [formGroup]="timeOfDay">
                  <li class="list-group-item d-flex align-items-center">
                    <div class="d-flex align-items-center w-100">
                      <label class="form-label me-2 mb-0">Time of Day</label>
                      <select class="form-select w-auto ms-auto" formControlName="value"
                        (change)="updateSunPosition(timeOfDay)" style="cursor: pointer">
                        @for (option of skyboxOptions; track option) {
                          <option [value]="option.value">
                            {{ option.display }}
                          </option>
                        }
                      </select>
                    </div>
                  </li>
                </ng-container>
              }
              @if (scene.type == 'Virtual Tour') {
                <li class="list-group-item">
                  <label class="form-label mb-1 d-block">Rotation offset (all viewpoints)</label>
                  <shared-rotation-offset-toolbar
                    [initial]="sceneRotationOffsetMatrix"
                    (matrixChange)="onSceneRotationOffsetChange($event)">
                  </shared-rotation-offset-toolbar>
                  <small class="text-muted d-block mt-1">
                    Applies to every viewpoint in this scene. Per-viewpoint edits override this.
                  </small>
                </li>
              }
            </ul>
          </div>
        </form>